import React from 'react';

export default class ContactForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div id="contact-form" className="contatct-form">
                <div className="loader"></div>
                <form
                    action="mail.php"
                    className="contactForm"
                    name="cform"
                    method="post"
                >
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="name">
                                Name<span className="required">*</span>
                            </label>
                            <span className="name-missing">
                                Please enter your name
                            </span>
                            <input
                                id="name"
                                name="name"
                                type="text"
                                value=""
                                size="30"
                            />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="e-mail">
                                Email<span className="required">*</span>
                            </label>
                            <span className="email-missing">
                                Please enter a valid e-mail
                            </span>
                            <input
                                id="e-mail"
                                name="email"
                                type="text"
                                value=""
                                size="30"
                            />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="url">Website</label>
                            <input
                                id="url"
                                name="url"
                                type="text"
                                value=""
                                size="30"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="message">Add Your Comment</label>
                            <span className="message-missing">
                                Say something!
                            </span>
                            <textarea
                                id="message"
                                name="message"
                                cols="45"
                                rows="10"
                            ></textarea>
                            <input
                                type="submit"
                                name="submit"
                                className="button"
                                id="submit_btn"
                                value="Send Message"
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

ContactForm.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/ContactForm.jsx